<template>
    <div class="loader" v-if="isLoading">
        <div class="loader__circle-list">
            <span class="loader__circle-item"></span>
            <span class="loader__circle-item"></span>
            <span class="loader__circle-item"></span>
        </div>
        <p class="loader__text">We are downloading profile, it may take a minute. Please wait :)</p>
    </div>
</template>
<script>
export default {
    name: "Loader",
    data() {
        return {
            isLoading: false,
        }
    },
    created() {
        this.$root.$on('loader-state-change', (state) => {
            this.isLoading = state;
        })
    },
}
</script>
